const VideoControls = (($) => {
    class VideoClass {
        constructor(node) {
            this.node = node;
            this.$node = $(this.node); // This represents the whole container
            this.$video = this.$node.find('video[data-action="hover"]');  // Finds the video within the container
        }

        init() {
            this.addEventListeners();
        }

        addEventListeners() {
            this.$node.on('mouseenter', () => {
                this.$video.get(0).play();
            });

            this.$node.on('mouseleave', () => {
                this.$video.get(0).pause(); // Only pauses the video on mouse leave
            });
        }
    }

    return {
        init({ selector } = {}) {
            $(selector).each((index, parent) => {
                const videoInstance = new VideoClass(parent);
                videoInstance.init();
            });
        },
    };
})(window.jQuery);

// DOM Ready
(($) => {
    $(document).ready(() => {
        VideoControls.init({
            selector: "[data-video]", // Selects the parent container which includes the data-video attribute
        });
    });
})(window.jQuery);
